import React from 'react'

function Navbar() {
  return (
    <nav>
      <img
        className='nav--logo'
        src='https://upload.wikimedia.org/wikipedia/commons/6/69/Airbnb_Logo_B%C3%A9lo.svg'
        alt='airbnb logo'
      />
    </nav>
  )
}

export default Navbar
